import React from 'react'
import ReactECharts from 'echarts-for-react';

function Matchstick() {
    const data = [10, 20, 30, 40, 50];  // 数据
    const categories = ['A', 'B', 'C', 'D', 'E'];  // 类目名称
  
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      xAxis: {
        type: 'value',  // 数值轴
        axisLabel: {
          color: '#000',
        },
      },
      yAxis: {
        type: 'category',  // 类目轴
        data: categories,  // 类目名称
        axisLabel: {
          color: '#000',
        },
      },
      series: [
        {
          name: '数量',
          type: 'bar',
          data: data,
          barWidth: 6,  // 火柴杆宽度
          itemStyle: {
            color: '#1B998B',  // 火柴杆颜色
            borderWidth: 2,    // 边框宽度
            borderColor: '#0F6A5C',  // 边框颜色
          },
          markPoint: {
            data: data.map((value, index) => ({
              xAxis: value,  // 数据值
              yAxis: categories[index],  // 类目
              symbol: 'circle',  // 小圆点
              symbolSize: 10,  // 圆点的大小
              itemStyle: {
                color: '#FF6347',  // 圆点颜色
              },
            })),
          },
        },
      ],
    };
  return (
    <div style={{width: "48%", height: "400px"}}>
            <ReactECharts option={option} style={{width: "100%", height: "90%"}} />
    </div>
  )
}

export default Matchstick
